import React, { PropsWithChildren, FC } from "react";
import theme from "../../theme";
import { ThemeProvider } from "styled-components";

export const TracpageThemeProvider: FC<
  PropsWithChildren<{ variant: keyof typeof theme }>
> = ({ children, variant }) => {
  return <ThemeProvider theme={theme[variant]}>{children}</ThemeProvider>;
};
